<template>
  <booking>
    <div class="booking-previous">
      <div class="lists" v-if="reservations.length">
        <booking-box-previous-event
          v-for="(item, index) in reservations"
          :key="index"
          :data="item"
          v-on:model="reLoadData"
        ></booking-box-previous-event>
      </div>
      <div class="no-data" v-else>
        <div class="message">There is no Message</div>
      </div>
    </div>
  </booking>
</template>

<script>
import Booking from '@/components/user/Booking'
import BookingBoxPreviousEvent from '@/components/common/BookingBoxPreviousEvent'
import { getRequestReservationsPrevious } from '@/api/reservation'

export default {
  name: 'booking-previous',
  components: { BookingBoxPreviousEvent, Booking },
  data() {
    return {
      reservations: []
    }
  },
  created() {
    this.getRequestReservationsPrevious()
  },
  methods: {
    reLoadData() {
      console.log('reload')
      // this.$router.push({path:'/user/booking/previous'})
    },
    getRequestReservationsPrevious() {
      console.log('uid:', this.$store.getters.userInfo.uid)
      getRequestReservationsPrevious(this.$store.getters.userInfo.uid).then(
        res => {
          this.reservations = res
          this.$emit('input', res.length)
          console.log('BookingUPCoomingEvent', res)
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.booking-previous {
  .lists {
    margin: 30px 0 0 0;
    .request-box {
    }
  }
  .no-data {
    height: 200px;
    position: relative;
    margin: 10px 0 0 0;
    .message {
      margin: auto;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 200px;
      text-align: center;
      height: 20px;
    }
    background-color: #f5f5f5;
  }
}
</style>
